"use client";

import { c as _c } from "react/compiler-runtime";
import { HugeiconsIcon } from "@hugeicons/react";
import type { Route } from "next";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { SidebarGroup, SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "@/components/ui/sidebar";
import { isSidebarNavItemActive, type SidebarNavItem } from "@/config/sidebar-navigation";
import { cn } from "@/lib/utils";
type SidebarNavSectionProps = {
  items: SidebarNavItem[];
  className?: string;
};
export function SidebarNavSection(t0) {
  const $ = _c(17);
  const {
    items,
    className
  } = t0;
  const pathname = usePathname();
  const {
    isMobile,
    setOpenMobile
  } = useSidebar();
  let t1;
  if ($[0] !== isMobile || $[1] !== setOpenMobile) {
    t1 = () => {
      if (isMobile) {
        setOpenMobile(false);
      }
    };
    $[0] = isMobile;
    $[1] = setOpenMobile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleNavClick = t1;
  let t2;
  if ($[3] !== className) {
    t2 = cn(className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleNavClick || $[6] !== items || $[7] !== pathname) {
    let t4;
    if ($[9] !== handleNavClick || $[10] !== pathname) {
      t4 = item => <SidebarMenuItem key={item.key}><SidebarMenuButton asChild={true} isActive={isSidebarNavItemActive(pathname, item)} tooltip={item.label}><Link href={item.href as Route} onClick={handleNavClick}><HugeiconsIcon icon={item.icon} /><span className="group-data-[collapsible=icon]:hidden">{item.label}</span></Link></SidebarMenuButton></SidebarMenuItem>;
      $[9] = handleNavClick;
      $[10] = pathname;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = items.map(t4);
    $[5] = handleNavClick;
    $[6] = items;
    $[7] = pathname;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[12] !== t3) {
    t4 = <SidebarMenu>{t3}</SidebarMenu>;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t4) {
    t5 = <SidebarGroup className={t2}>{t4}</SidebarGroup>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}